import React from 'react';
import { Link } from 'react-router-dom';
import CalculatorModal from './CalculatorModal';
import './JobDetailsStyle.scss';
import { Navigate } from 'react-router-dom';
import CustomModalView from '../../common/input/customModal/customModalView';
import moment from "moment";

import helpimg from '../../assets/images/ready-to-help.png';
import calimg from '../../assets/images/price-calculator.png';
import consultimg from '../../assets/images/consultant-details-1.jpg';
import ApplyModal from '../find-jobs/ApplyModal';
import DOMPurify from 'dompurify'

const JobDetailsView = (props) => {
    console.log('job________detauls_________props', props)
    //console.log("today_date", props.today_date,"Close_date",props.closing_job_date);
// if (localStorage.getItem("token")) {
    return (
        <>
            {/* cc search section open */}
            <section className="findjob-search-section">
                <div className="container">
                    <div className="row justify-content-md-center">
                        <div className="col-md-12 findjob-search-heading">
                            <h2 className="cc-main_title--lg text-center">Find a job</h2>
                        </div>
                        <div className="col-md-8 findjob-search-bar">
                            <div className="cc-searchbar">
                                <div className="srch-fld-row">
                                    <div className="srch-fld-col"><input type="text" placeholder="Postcode" /></div>
                                    <div className="srch-fld-col">
                                        <select>
                                            <option>Select Profession</option>
                                            <option>Doctor</option>
                                        </select>
                                    </div>
                                    <div className="srch-fld-col srch-btn-col">
                                        <input type="submit" value="" className="form-submit-btn" />
                                    </div>
                                </div>
                            </div>
                            <h5 className="job-search-info">List of Jobs will apear based on the postcode given by user</h5>
                        </div>
                    </div>
                </div>
            </section>
            {/* cc search section end */}

            {/* jobs wrapper start */}
            <section className="jobs-wrapper common-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 pad-bottom-20">
                            {props.applied ?
                            null
                            :
                            <Link href="/find-jobs" className="btn-back"><i className="fa fa-long-arrow-left"></i> Back to Job Search</Link>
                            }
                            {/* <Link to="#" className="btn-back"><i className="fa fa-long-arrow-left"></i> Back to Job Search</Link> */}
                        </div>
                        <div className="col-lg-8">
                            <div className="job-box details-box">
                                <h2>{props.job_detail.title}</h2>
                                <div className="job-requirement">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            Job ID:
                                        </div>
                                        <div className="col-sm-9"><strong>{props.job_detail.job_number}</strong></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            PostCode:
                                        </div>
                                        <div className="col-sm-9"><strong>{props.job_detail.postcode}</strong></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            Requirement:
                                        </div>
                                        <div className="col-sm-9"><strong>{props.job_detail.carer_type}</strong></div>
                                    </div>



                                    <div className="row">
                                        <div className="col-sm-3">
                                            Qualification:
                                        </div>
                                        <div className="col-sm-9"><strong>{props.qualification}</strong></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            Experience:
                                        </div>
                                        <div className="col-sm-9"><strong>{props.job_detail.experience_type}</strong></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            Language:
                                        </div>
                                        <div className="col-sm-9"><strong>{props.job_detail.language_name}</strong></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            Remuneration:
                                        </div>
                                        <div className="col-sm-9"><strong>£ {props.job_detail.renumerate && props.job_detail.renumerate.replace("£","")}</strong></div>
                                    </div>
                                </div>
                                <div className="job-description">
                                    <h4>Job description</h4>
                                    <p><span className="more" id="description "dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.job_detail.description)}} ></span></p>
                                </div>
                                <div className="job-date">
                                    <span>Start Date: {moment(props.job_detail.start_date).format("DD-MM-YYYY")}</span>
                                </div>
                                <div className="job-view">
                                    <ul>
                                        <li><i className="fa fa-eye"></i> <span>Views{" "}{props.job_detail.views}</span> </li>
                                        <li><i className="fa fa-wpforms"></i> <span>Applications {props.job_detail.application_count}</span></li>
                                        <li><i className="fa fa-calendar"></i> <span>Closing Date {props.job_detail.close_date}</span> </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="consultant-details">
                                <h3>Consultant Details</h3>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="pic">
                                            <img src={consultimg} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-sm-9 consultant-txt">
                                        <h4>{props.user.first_name} {props.user.last_name}</h4>
                                        <ul>
                                            <li><i className="fa fa-eye"></i> Consultant  |  Health Care Jobs Requirement</li>
                                            <li><i className="fa fa-phone"></i> 353 (0) 21 2568742</li>
                                            <li><i className="fa fa-send"></i> <Link href={'mailto:' +props.user.email}>{props.user.email}</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="job-summary">
                                <h3>Job Summary</h3>
                                <ul>
                                    {props.job_detail.job_type == 'private' ?
                                    <li><i className="fa fa-map-marker"></i> {props.job_detail.postcode}</li>
                                    :
                                    <li><i className="fa fa-map-marker"></i> {props.job_detail.postcode}</li>
                                    }
                                    <li><i className="fa fa-briefcase"></i> {props.job_detail.contracttype}</li>
                                    <li><i className="fa fa-flag"></i> Ref ID: {props.job_detail.id} </li>
                                    <li><i className="fa fa-calendar"></i> Close Date: {props.job_detail.close_date}</li>
                                    {props.shift_select_timing.map((repeate_list) => ( 
                                        <>
                                    <li><i className="fa fa-clock-o"></i> {repeate_list.shift_detail}</li>
                                    {parseInt(repeate_list.shift_available) === 0 ?
                                    <li className="form-error-msg-post" style={{fontWeight: '500',color:"red"}}>{repeate_list.shift_available} No Shifts Available</li>
                                    :
                                    <li className="form-error-msg-post" style={{color: '#6da722',fontWeight: '500'}}>{repeate_list.shift_available} Still Available</li>
                                    }
                                    </>
                                    ))}
                                </ul>
                                <div className="job-btn">
                               
                                        <Link href="#" onClick={(e) =>props.applyShowCustomModalFavorite(props.job_detail.id)} className="btn-green">Add to Favourite</Link>
                                    
                                   

                                    {props.applied ?
                                     <Link href="" style={{background: '#8c8687'}} className="btn-red">You've Applied</Link>
                                    :
                                      <span>  {  props.today_date > props.closing_job_date ? null :  <Link href="" onClick={(e) => props.applyShowCustomModal(props.job_detail.id)} className="btn-red">APPLY JOB <i className="fa fa-arrow-right"></i></Link>}</span>
                                    }
                                </div>
                            </div>
                            <div className="price-calculator">
                                <button onClick={props.showCalculator}>
                                    <img src={calimg} alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cc-help_img">
                    <img src={helpimg} alt="ready to help image" />
                </div>
            </section>
            {/* jobs wrapper end */}

            {/* <CalculatorModal
                modal_show={props.modal_show}
                hideCalculator={props.hideCalculator}
            /> */}
            <CustomModalView
                modal_show={props.modal_show_custom}
                authResponse={props.authResponse}
                showCustomModal={props.showCustomModal}
                hideCustomModal={props.hideCustomModal}

                />

                <ApplyModal
                 apply_modal_show={props.apply_modal_show}
                 applyHideCustomModal={props.applyHideCustomModal}
                 applyjob={props.applyjob}
                 shift_select_timing={props.shift_select_timing}
                 handelShift={props.handelShift}
                 applied_shift_id={props.applied_shift_id}
                 apply_job_check={props.apply_job_check}
                 applyfavorite = {props.applyfavorite}
                />
        </>
    )
//     } else {
//     return (
//       <Navigate to="/login" />
//     )
//   }
}

export default JobDetailsView;
